import React, { useEffect, useRef, useState } from "react";
import { Floater } from "frontend/ui-components/floaters/floater";
import { useOnClickOutside } from "usehooks-ts";
import { SearchContextProvider } from "./context/search-context";
import tracking from "frontend/tracking";
import { SEARCHBAR_TRACKING_ACTIONS } from "./events";
import styles from "./search-section.module.css";
import { SearchBar as SearchBarV2, SearchContainer as SearchContainerV2 } from "./components-v2";

export const SearchSection = () => {
  const searchBarRef = useRef<HTMLDivElement>(null);
  const floaterRef = useRef<HTMLDivElement>(null);
  const [isContainerOpen, setIsContainerOpen] = useState(false);

  useOnClickOutside(floaterRef, (event) => {
    if (event.target instanceof HTMLElement && !searchBarRef.current?.contains(event.target)) {
      setIsContainerOpen(false);
    }
  });

  useEffect(() => {
    if (isContainerOpen) {
      tracking.trackAnalyticsEvent(SEARCHBAR_TRACKING_ACTIONS.searchbar_clicked);
    }
  }, [isContainerOpen]);

  return (
    <SearchContextProvider>
      <div className={styles.wrapperV2}>
        <SearchBarV2 ref={searchBarRef} isOpen={isContainerOpen} setIsOpen={setIsContainerOpen} />
        {isContainerOpen && (
          <Floater
            relativeTo={searchBarRef}
            ref={floaterRef}
            side="bottom"
            boundary="none"
            margin={-7}
            extraStyle={{
              zIndex: 500,
            }}
          >
            <SearchContainerV2 />
          </Floater>
        )}
      </div>
    </SearchContextProvider>
  );
};
